import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

interface Props {
    count: number;
}

function ProductSkeleton() {
  return (
    <Box sx={{ width: 300 }}>
      <Skeleton animation="wave" variant="rectangular" width={300} height={200} />
      <Box sx={{ pt: 0.5 }} />
      <Skeleton animation="wave" variant="text" width="60%" height={30} />
    </Box>
  );
}

export default function ProductsSkeletonGrid({ count }: Props) {
  return (
    <Box
      sx={{
        alignItem: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,

      }}
    >
      {[...Array(count)].map((_, index) => (
        <Box key={index} sx={{ width: 300 }}>
          <ProductSkeleton />
        </Box>
      ))}
    </Box>
  );
}